/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, forwardRef, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {WidgetValidator} from '@pt/pt-models';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ValidatorGenerator} from '../../utils';

@Component({
  selector: 'pt-input-multiple-text',
  templateUrl: './input-multiple-text.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputMultipleTextComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputMultipleTextComponent),
      multi: true
    }
  ],
  styles: [`
    .form-group-ng-select .is-invalid {
      border-color: #dc3545 !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class InputMultipleTextComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() controlName: string;
  @Input() validators: WidgetValidator[];
  @Input() label: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;

  public formGroup: FormGroup;
  isRequired: boolean;
  inputId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.inputId = 'ptWFilteredSelect_' + this.controlName;

    this.isRequired = ValidatorGenerator.validatorsContainsRequired(this.validators);

    this.setFormGroup();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      if (this.onChanged) {
        this.onChanged(t.value);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });
  }

  writeValue(obj: string[]): void {
    this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.controls.value.disable();
    } else {
      this.formGroup.controls.value.enable();
    }
  }

  validate() {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private setFormGroup() {
    const validator = ValidatorGenerator.generateValidator(this.validators);
    this.formGroup = new FormGroup({
      value: new FormControl(null, validator)
    });
  }
}

export interface InputFilteredMultipleSelectData<E> {
  bindLabel: string;
  bindValue: string;
  items: E[];
}
